import { useFlagStore } from 'stores/flagStore'
import { usePackageStore } from 'stores/packageStore'

const hasActiveFlag = (flags) => flags.some((f) => f.state !== 'accepted')

export function useFlagRequirementCounts() {
  const requirementFlags = useFlagStore((s) => s.requirementFlags)
  const documentFlags    = useFlagStore((s) => s.documentFlags)
  const requirements     = usePackageStore((s) => s.package?.visible_package_requirements) ?? []

  const flaggedRequirements = requirements.filter((r) => {
    const hasReqFlag = hasActiveFlag(requirementFlags[r.id] ?? [])
    const hasDocFlag = (r.package_documents ?? []).some((d) => hasActiveFlag(documentFlags[d.id] ?? []))
    return hasReqFlag || hasDocFlag
  })

  const flaggedRequirementIds = new Set(flaggedRequirements.map((r) => r.id))

  return {
    flaggedRequirements,
    incompleteCount: flaggedRequirements.length,
    completeCount: requirements.filter((r) => r.approved && !flaggedRequirementIds.has(r.id)).length,
    total: requirements.length,
  }
}
